export const DASHBOARD_LAYOUT_FIELD_LABEL_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-[color:var(--brand-tropical-surf)]"

export const DASHBOARD_LAYOUT_FIELD_DESC_CLASS =
  "font-[family-name:var(--font-primary)] text-sm font-normal text-[#6b7280] dark:!text-white"

const MINI_STAT_SLOT_ID_PREFIX = "mini-stat-slot-"

export function miniStatSlotId(index: number): string {
  return `${MINI_STAT_SLOT_ID_PREFIX}${index}`
}

export function isMiniStatSlotId(id: string | number): boolean {
  return String(id).startsWith(MINI_STAT_SLOT_ID_PREFIX)
}

export function parseMiniStatSlotId(id: string | number): number | null {
  const raw = String(id)
  if (!raw.startsWith(MINI_STAT_SLOT_ID_PREFIX)) return null
  const index = Number(raw.slice(MINI_STAT_SLOT_ID_PREFIX.length))
  return Number.isFinite(index) ? index : null
}

/** Keep viewport position stable across layout draft updates (e.g. card swap). */
export function preserveViewportScroll(action: () => void): void {
  const scrollX = window.scrollX
  const scrollY = window.scrollY
  action()
  window.requestAnimationFrame(() => {
    window.scrollTo(scrollX, scrollY)
  })
}
